import { Box, Flex, Spinner } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { FC } from "react";
import { FormatExpiryTimeText } from "./InviteCodeHelpers";
import { ChakraFAIcon } from "@/components/ui/Icon";

interface InviteCodeContentProps {
	enabled: boolean;
	inviteCode: string;
	inviteCodeExpiry?: string;
	isLoading: boolean;
	onRegenerate: () => void;
	currentTimestampSource: () => number;
}

export const InviteCodeContent: FC<InviteCodeContentProps> = ({
	enabled,
	inviteCode,
	inviteCodeExpiry,
	isLoading,
	onRegenerate,
	currentTimestampSource,
}) => {
	const [expiryTimeText, setExpiryTimeText] = useState<string>("");

	const updateExpiry = () => {
		if (inviteCodeExpiry !== undefined) {
			const expiryNumber = parseInt(inviteCodeExpiry);
			setExpiryTimeText(FormatExpiryTimeText(currentTimestampSource(), expiryNumber));
		}
	};

	useEffect(() => {
		updateExpiry();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [inviteCodeExpiry, currentTimestampSource]);

	useEffect(() => {
		const interval = setInterval(() => {
			updateExpiry();
		}, 1000);
		return () => clearInterval(interval);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [inviteCodeExpiry, currentTimestampSource]);

	if (!enabled) {
		return <></>;
	}

	return (
		<>
			<Flex alignItems="end">
				<Box className="InviteCode_code">{inviteCode ? inviteCode : "----"}</Box>
				{isLoading ? (
					<Box pb="10px">
						<Spinner
							color="white"
							width={"12px"}
							height={"12px"}
							data-testid="inviteCodeLoadingIcon"
							className="InviteCode_codeRegenerate"
						/>
					</Box>
				) : (
					<Box pb="10px" onClick={onRegenerate} cursor="pointer">
						<ChakraFAIcon
							icon="fa-recycle"
							variant="solid"
							color="inherit"
							boxSize={18}
							data-testid="inviteCodeRegenerateIcon"
							className="InviteCode_codeRegenerate"
						/>
					</Box>
				)}
			</Flex>
			<Box>
				<Flex>Code Expires in:</Flex>
				<Flex>{expiryTimeText}</Flex>
			</Box>
		</>
	);
};
